import { client } from 'utils/http';
import { useToast } from './toast';
import { CacheKeys } from 'utils/cacheKeys';
import { useBusiness } from 'providers/context/BusinessProvider';
import { getCookie } from 'utils/helperFunctions';
import { businessOnboarding } from '@/routes/config';

export const useAxiosWithToast = () => {
  const { showToast, ToastComponent } = useToast();
  const { selectedBusiness } = useBusiness();

  client.interceptors.response.use(
    (response) => {
      const skipSuccessToast = (response.config as { skipSuccessToast?: boolean }).skipSuccessToast;
      const successMessage = response?.data?.meta?.message;
      if (!skipSuccessToast && successMessage && typeof successMessage === 'string') {
        showToast(successMessage, 'success');
      }
      return response;
    },
    (error) => {
      const statusCode = error?.status ?? error?.response?.status;
      if (statusCode === 401) {
        const requestUrl = error.config?.url || error.request?.responseURL || '';
        const rawError = error.response?.data?.error;
        const errorMessage = typeof rawError === 'string' ? rawError : 'An unexpected error occurred';
        const isKickcallAgency = getCookie(CacheKeys.kickcallAgency) === 'true';

        if (requestUrl.includes('send_code') && error.response?.data?.error === 'Unauthorized') {
          if (errorMessage) {
            showToast(errorMessage, 'error');
          }
          if (isKickcallAgency) {
            window.location.href = 'https://kickcall.ai/contact-us';
          } else {
            window.location.href = `${businessOnboarding.base}/${businessOnboarding.stage1()}`;
          }
          return Promise.reject(error);
        }

        if (errorMessage) {
          showToast(errorMessage, 'error');
        }
        let redirectUrl = '/auth/logout';
        const isOnboardingLoginRequest = requestUrl.includes('public/onboarding_forms/login');

        if (isOnboardingLoginRequest) {
          redirectUrl = '/business-onboarding/login';
        }

        setTimeout(() => {
          window.location.href = redirectUrl;
        }, 4000);
      }
      if (statusCode === 404) {
        if (error.response?.data?.error !== 'Location not found') {
          // window.location.href = '/404';
        }
      }
      const rawError = error.response?.data?.error;
      const errorMessage = typeof rawError === 'string' ? rawError : 'An unexpected error occurred';
      if (errorMessage !== 'Location not found') {
        showToast(errorMessage, 'error');
      }
      return Promise.reject(error);
    }
  );

  client.interceptors.request.use(
    (config) => {
      let businessIds;
      if (localStorage.getItem(CacheKeys.businessIds)) {
        businessIds = JSON.parse(localStorage.getItem(CacheKeys.businessIds) ?? '');
      }
      const selectFirstBusinessDefault = businessIds?.length > 0 ? businessIds[0] : selectedBusiness;
      config.headers['Business-Id'] = selectFirstBusinessDefault || '';
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return { ToastComponent };
};
